// Documentation URL Configuration
// Centralized documentation links for maintainability

const DOCS_BASE_URL = import.meta.env.VITE_DOCS_BASE_URL || '/docs';

export const DOCUMENTATION_URLS = {
  // Accuracy Metrics Guide
  accuracy_metrics: `${DOCS_BASE_URL}/features/ACCURACY_METRICS_GUIDE.md`,
  prediction_metrics: `${DOCS_BASE_URL}/features/ACCURACY_METRICS_GUIDE.md#prediction-metrics`,
  risk_metrics: `${DOCS_BASE_URL}/features/ACCURACY_METRICS_GUIDE.md#risk-metrics`,

  // Operations & Maintenance
  feature_flags: `${DOCS_BASE_URL}/current/operations/FEATURE_FLAGS_OPERATIONS.md`,
  accuracy_dashboard_ops: `${DOCS_BASE_URL}/current/operations/ACCURACY_DASHBOARD_OPS_RUNBOOK.md`,

  // API Documentation
  health_endpoints: `${DOCS_BASE_URL}/api/HEALTH_ENDPOINTS.md`,

  // Proposals & Design Docs
  prediction_confidence: `${DOCS_BASE_URL}/proposals/PREDICTION_CONFIDENCE_METRICS.md`,
};

export default DOCUMENTATION_URLS;
